import {Component, OnInit} from '@angular/core';
import {FormGroup, UntypedFormBuilder, Validators} from "@angular/forms";
import {LipaService} from "../../../../Modules/beneficiary/Modules/lipa/Services/lipa.service";
import {BenefAdvancedSearchModel} from "../../Models/BenefAdvancedSearchModel";
import {Subscription} from "rxjs";
import {CustomSwal} from "../../../../Modules/Shared/Services/CustomSwal";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-benef-advanced-search-progress',
  templateUrl: './benef-advanced-search-progress.component.html',
  styleUrls: ['./benef-advanced-search-progress.component.scss']
})
export class BenefAdvancedSearchProgressComponent implements OnInit {
  advancedSearchForm: FormGroup;
  savedAdvancedSearchDetails: BenefAdvancedSearchModel;
  private subscriptions: Subscription[] = [];
  year: number = new Date().getFullYear();

  get f() {
    return this.advancedSearchForm?.controls;
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private lipaService: LipaService,
  ) {
  }

  ngOnInit(): void {
    this.advancedSearchForm = this.formBuilder.group({
      refNo: ['', Validators.required]
    })
  }

  onChangeRefNo(value: any) {
    this.savedAdvancedSearchDetails = null;
    this.subscriptions.push(this.lipaService.getBenefAdvancedSearchProgress(value.refNo).subscribe(
      {
        next: (response: BenefAdvancedSearchModel) => {
          this.savedAdvancedSearchDetails = response;
          CustomSwal.toastSuccess(`Successfully Fetched Advanced Search Request Details`)
        },
        error: (error: HttpErrorResponse) => {
          CustomSwal.toastFailed(error.error.detail);
        }
      }
    ));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
